import {Component, OnInit} from '@angular/core';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from '@ngx-translate/core';
import {FormBuilder, FormControl, FormGroup, ValidatorFn} from '@angular/forms';
import {ImmutableListRepositoryService} from '../immutable-list-repository.service';
import {FieldType} from '../../reflexive-model/field-type.enum';
import {ReflexiveField} from '../../reflexive-model/reflexive-field';
import { Observable } from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-gelios-input-array-field',
  templateUrl: './gelios-input-array-field.component.html',
})
export class GeliosInputArrayFieldComponent extends GeliosFieldBaseComponent implements OnInit {
  fieldType = FieldType;
  items: Observable<Array<{id: string, name: string}>>;
  childFormGroup: FormGroup;
  childFieldConfig: ReflexiveField;

  private _isRequired: boolean | null = null;

  constructor(
    protected translate: TranslateService,
    protected formBuilder: FormBuilder,
    protected immutableList: ImmutableListRepositoryService
  ) {
    super(translate);
  }

  ngOnInit() {
    super.ngOnInit();
    this.childFormGroup = this.formGroup.controls[this.fieldName] as FormGroup;
    this.childFieldConfig = this.model.fields[this.fieldName].inputArray.childFieldConfig;
    this.items = this.reflexiveField.inputArray.items.pipe(
      map(items => (Array.isArray(items) ? items : [])),
      map(
        items => items.map(
          item => ({
            id: item[this.reflexiveField.inputArray.keyField || 'id'],
            name: item[this.reflexiveField.inputArray.displayedField || 'name'],
          })
        )
      )
    );
    this.items.subscribe(
      items => console.log(items)
    );
  }

  isRequired(): boolean {
    if (this._isRequired === null) {
      const fakeControl = new FormControl('');
      this._isRequired = (!!this.reflexiveField.validators) && this.reflexiveField.validators.reduce(
        (carry: boolean, validator: ValidatorFn) => carry
          || (
            validator(fakeControl) && validator(fakeControl).required),
        false
      );
    }
    return this._isRequired;
  }

  onItemValueChange(event, itemId) {
    this.valueChange.emit({fieldName: this.fieldName, value: this.formGroup.controls[this.fieldName].value});
  }
}
